
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured/[slug]",
      function () {
        return require("private-next-pages/featured/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/featured/[slug]"])
      });
    }
  